import { useRef } from 'react'

import Webcam from 'react-webcam'
import * as handpose from '@tensorflow-models/handpose'
import '@tensorflow/tfjs'
import { drawKeypoints, drawHands, drawBoundingBox } from '../utils/model'
// base code: https://codesandbox.io/s/posenet-react-hm35t

export const Landing = () => {
  const webcamRef = useRef(null)
  const canvasRef = useRef(null)

  const detectWebcamFeed = async (handpose_model) => {
    if (
      typeof webcamRef.current !== 'undefined' &&
      webcamRef.current !== null &&
      webcamRef.current?.video?.readyState === 4
    ) {
      // Get Video Properties
      const video = webcamRef.current.video
      const videoWidth = webcamRef.current.video.videoWidth
      const videoHeight = webcamRef.current.video.videoHeight
      // Set video width
      webcamRef.current.video.width = videoWidth
      webcamRef.current.video.height = videoHeight
      // Make Estimation
      const predictions = await handpose_model.estimateHands(video, true)
      drawResult(predictions, video, videoWidth, videoHeight, canvasRef)
    }
  }

  const drawResult = (predictions, video, videoWidth, videoHeight, canvas) => {
    if (canvas.current !== null) {
      const ctx = canvas.current.getContext('2d')
      canvas.current.width = videoWidth
      canvas.current.height = videoHeight
      drawBoundingBox(predictions, ctx)
      drawKeypoints(predictions, ctx)
      drawHands(predictions, ctx)
    }
  }

  const detect = async () => {
    const handpose_model = await handpose.load()
    setInterval(() => {
      detectWebcamFeed(handpose_model)
    }, 500)
  }

  detect()

  return (
    <>
      <div style={{ position: 'absolute', height: '100%', width: '100%' }}>
        <Webcam
          videoConstraints={{
            facingMode: 'user',
          }}
          ref={webcamRef}
          audio={false}
          mirrored={true}
          style={{
            position: 'absolute',
            marginLeft: 'auto',
            marginRight: 'auto',
            left: 0,
            right: 0,
            textAlign: 'center',
            height: '100%',
            width: 'auto',
          }}
        />
        <canvas
          ref={canvasRef}
          style={{
            position: 'absolute',
            marginLeft: 'auto',
            marginRight: 'auto',
            left: 0,
            right: 0,
            textAlign: 'center',
            height: '100%',
            width: 'auto',
          }}
        />
      </div>
    </>
  )
}
